import React from "react";
import style from "./index.module.scss";
// import styled from "styled-components";
import * as Type from "../../config";
interface Item {
  title: string,
  desc: string
}
export interface IAppProps {
  bottomIconUrl: string;
  isShowSubTitle?: string;
  backColor: string;
  wrapPadding?: Type.WrapPadding;
  title: string;
  list: Item[];
  backIcon: string;
  getData: any;
  titlePosition: string[];
}
const App: React.FC<IAppProps> = props => {
  const {
    title,
    list
  } = props;

  return (
    <div className={`${style.app} ${style.appContaner}`}>
      <div className={style.appInner}>
        <div className={style.appTitle}>
          <img className={style.icon} src="https://img10.360buyimg.com/imagetools/jfs/t1/136695/40/12131/353/5f85201fE983033c6/e742dfbed70ac12c.png" alt=""/>
          <h1 className={style.title}>{title}</h1>
          <img className={style.icon} src="https://img12.360buyimg.com/imagetools/jfs/t1/125655/25/14837/355/5f8542a9Ed965e72e/8f20a424322649d9.png" alt=""/>
        </div>
        <div className={style.mainContent}>
          {list &&
            list.map((d, i) => (
              <div className={style.contentItem} key={i}>
                <p className={style.contentItemMain}>{d.title}</p>
                <p className={style.contentItemSub}>{d.desc}</p>
                {i % 4 !== 3 && <div className={style.contentSeparator}></div>}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default App;
